const newPasswordValidationFn = (label, isRequired) => (value) => {
  const hasNumberRegex = /[0-9]/;
  // eslint-disable-next-line no-useless-escape
  const hasSpecialRegex = /[\^\$\*\.\[\]\{\}\(\)\?\-"!@#%&/\\,><':;\|_~`]/;
  if (isRequired && value === '') {
    return `${label} is required.`;
  }
  const hasUppercaseRegex = /[A-Z]/;
  const hasLowercaseRegex = /[a-z]/;
  if (!hasNumberRegex.test(value)) {
    return `${label} must have a number character`;
  }
  if (value.length < 8) {
    return `${label} must have a minimum of 8 characters.`;
  }
  if (!hasSpecialRegex.test(value)) {
    return `${label} must have at least one of: ^ $ * . [ ] { } ( ) ? - " ! @ # % & / \\ , > < ' : ; | _ ~ \``;
  }
  if (!hasUppercaseRegex.test(value)) {
    return `${label} must have an uppercase character`;
  }
  if (!hasLowercaseRegex.test(value)) {
    return `${label} must have a lowercase character`;
  }
  return null;
};

export default newPasswordValidationFn;
